const countryCode = localStorage.getItem('countryCode') || 'QC';
const tax = localStorage.getItem('tax') || 'IN';
export default () => ({
  actionBar: {
    country: countryCode,
    tax: tax,
  },
});
